import fetch, { toQueryString } from '../fetch';

import { ORGANIZATIONS_BASE_URL } from './organizationsAPI';

const JobGroupAPI = () => {
  const endpoint = `${ORGANIZATIONS_BASE_URL}/job-group`;

  const getJobGroup = async (jobGroupId, profileKey) => {
    try {
      const headers = (profileKey != null) ? { 'X-Profile-Key': profileKey } : {};
      return await fetch(`${endpoint}/${jobGroupId}`, { method: 'GET', headers });
    } catch (error) {
      throw error;
    }
  };

  const createJobGroup = async (data, profileKey) => {
    try {
      const headers = (profileKey != null) ? { 'X-Profile-Key': profileKey } : {};
      const response = await fetch(endpoint, { method: 'POST', headers, body: data });
      return response;
    } catch (error) {
      throw error;
    }
  };

  const getJobGroups = async (query, profileKey) => {
    try {
      const getUrl = `${endpoint}-list${toQueryString(query)}`;
      const headers = (profileKey != null) ? { 'X-Profile-Key': profileKey } : {};
      return await fetch(getUrl, { method: 'GET', headers });
    } catch (error) {
      throw error;
    }
  };

  const updateJobGroups = async (jobGroupId, data) => {
    try {
      return await fetch(`${endpoint}/${jobGroupId}`, { method: 'PATCH', body: { data } });
    } catch (error) {
      throw error;
    }
  };

  return {
    createJobGroup,
    getJobGroup,
    getJobGroups,
    updateJobGroups,
  };
};

export default JobGroupAPI;
